import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchConversations } from '../services/patientApi';
import { queryKeys } from '../queryKeys';

export const useConversationsQuery = (search?: string) =>
  useInfiniteQuery({
    queryKey: queryKeys.conversations.list(search),
    queryFn: ({ pageParam }) => fetchConversations(search, pageParam),
    getNextPageParam: (lastPage) => lastPage.nextPage ?? undefined,
    initialPageParam: 1,
  });
